import * as React from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import styled from "styled-components";
import StickyBottomActions from "views/components/widgets/StickyBottomActions";
import SaveOrCancelButtons from "views/components/widgets/SaveOrCancelButtons";
import ElementConfigurationSection from "./ElementConfigurationSection";
import ElementsConfigurationActions from "./ElementsConfigurationActions";
const Container = styled.div`
  position: relative;
  height: 100%;
`;
const _sortConfiguredElements = (values, aggregationElementsByKey) => Object.keys(aggregationElementsByKey).map(
  (elementKey) => [elementKey, values[aggregationElementsByKey[elementKey].key]]
).sort(
  ([elementKey1], [elementKey2]) => aggregationElementsByKey[elementKey1].order - aggregationElementsByKey[elementKey2].order
);
const ElementsConfiguration = ({ aggregationElementsByKey, config, onConfigChange, onCreate, onCancel }) => {
  const { t } = useTranslation("aggregation");
  const { values, setValues } = useFormikContext();
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    StickyBottomActions,
    {
      actions: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ElementsConfigurationActions, null), /* @__PURE__ */ React.createElement(SaveOrCancelButtons, { onCancel }))
    },
    /* @__PURE__ */ React.createElement("div", null, _sortConfiguredElements(values, aggregationElementsByKey).map(([elementKey, elementFormValues]) => {
      const aggregationElement = aggregationElementsByKey[elementKey];
      if (!aggregationElement) {
        throw new Error(`Aggregation element with key ${elementKey} is missing but configured for this widget.`);
      }
      const { component: ConfigurationSection, isEmpty } = aggregationElement;
      const empty = isEmpty(elementFormValues);
      if (!ConfigurationSection) return null;
      return /* @__PURE__ */ React.createElement(
        ElementConfigurationSection,
        {
          allowCreate: aggregationElement.allowCreate(values),
          isEmpty: empty,
          onCreate: () => onCreate(aggregationElement.key, values, setValues),
          elementTitle: aggregationElement.titleKey ? t(aggregationElement.titleKey) : aggregationElement.title,
          sectionTitle: aggregationElement.sectionTitleKey ? t(aggregationElement.sectionTitleKey) : aggregationElement.sectionTitle,
          key: aggregationElement.key
        },
        /* @__PURE__ */ React.createElement(ConfigurationSection, { config, onConfigChange })
      );
    }))
  ));
};
export default ElementsConfiguration;
